import createStore from '@store/configureStore';
import getPreloadedState from '@store/preloadedState';

const preloadedState = getPreloadedState();

const store = createStore(preloadedState);

export { store };
